import { DOCUMENT_TYPE_MASK, DOCUMENT_TYPES } from './constants'

export const fillMask = (mask, str) => {
    const input = str.split('')

    const maskedInput = mask
        .split('')
        .map(char => {
            if (char === 'X' || input[0] === char) {
                return input.shift() || ''
            }

            return char
        })
        .join('')

    return input.length === 0 && maskedInput.length === mask.length ? maskedInput : str
}

export const stripDocumentNumber = documentNumber => documentNumber?.replace(/[-./]/g, '')
export const fillDocumentNumberMask = (documentType, documentNumber, defaultValue) =>
    documentType && documentNumber ? fillMask(DOCUMENT_TYPE_MASK[documentType], documentNumber) : defaultValue

export const getTranslatedDocumentTypes = t =>
    DOCUMENT_TYPES.map(type => ({
        ...type,
        label: t(type.label),
    }))
